module.exports = __webpack_public_path__ + "img/orderbook.9cd4774c.png";